const ownerEvaluationMge = r => require.ensure([], () => r(require('@/page/ownerEvaluation/ownerEvaluationMge')), 'ownerEvaluationMge');
const ownerEvaluationList = r => require.ensure([], () => r(require('@/page/ownerEvaluation/ownerEvaluationList/ownerEvaluationList')), 'ownerEvaluationList');
const ownerEvaluationDetailList = r => require.ensure([], () => r(require('@/page/ownerEvaluation/ownerEvaluationDetailList/ownerEvaluationDetailList')), 'ownerEvaluationDetailList');
const OwnerEvaluationStatistics = r => require.ensure([], () => r(require('@/page/ownerEvaluation/OwnerEvaluationStatistics/OwnerEvaluationStatistics')), 'OwnerEvaluationStatistics');
const ownerEvaluationDetail = r => require.ensure([], () => r(require('@/page/ownerEvaluation/ownerEvaluationDetail/ownerEvaluationDetail')), 'ownerEvaluationDetail');
const orgScoreRank = r => require.ensure([], () => r(require('@/page/ownerEvaluation/orgScoreRank/orgScoreRank')), 'orgScoreRank');
const orgRankState = r => require.ensure([], () => r(require('@/page/ownerEvaluation/orgRankState/orgRankState')), 'orgRankState');
const orgRankStates = r => require.ensure([], () => r(require('@/page/orgRankStates/orgRankStates')), 'orgRankStates');
const institutionsEvaluation = r => require.ensure([], () => r(require('@/page/ownerEvaluation/institutionsEvaluation/institutionsEvaluation')), 'institutionsEvaluation');
const PropertyServeScore = r => require.ensure([], () => r(require('@/page/ownerEvaluation/PropertyServeScore/PropertyServeScore')), 'PropertyServeScore');
const otherReasonList = r => require.ensure([], () => r(require('@/page/ownerEvaluation/otherReasonList/otherReasonList')), 'otherReasonList');
const ownerAdviceList = r => require.ensure([], () => r(require('@/page/ownerEvaluation/ownerAdviceList/ownerAdviceList')), 'ownerAdviceList');
const PropertyProjectLists = r => require.ensure([], () => r(require('@/page/PropertyProjectLists/PropertyProjectLists')), 'PropertyProjectLists');
const DetailedCellRankings = r => require.ensure([], () => r(require('@/page/DetailedCellRankings/DetailedCellRankings')), 'DetailedCellRankings');
const statisticalDetails = r => require.ensure([], () => r(require('@/page/statisticalDetails/statisticalDetails')), 'statisticalDetails');
const evaluatePush = r => require.ensure([], () => r(require('@/page/evaluatePush/evaluatePush')), 'evaluatePush');

const ownerEvaluationRouter = {
  path: '',
  component: ownerEvaluationMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '业主评价管理',
  redirect: '/ownerEvaluationList',
  children: [{
      path: '/ownerEvaluationList',
      component: ownerEvaluationList,
      name: '业主评价列表',
      meta: {
        right: ['业主评价列表'],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/PropertyServeScore',
      component: PropertyServeScore,
      name: '业主评分',
      meta: {
        right: ['业主评分'],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/ownerEvaluationDetailList',
      component: ownerEvaluationDetailList,
      name: '评价明细列表',
      meta: {
        right: ['评价明细列表'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/otherReasonList',
      component: otherReasonList,
      name: '其他原因明细列表',
      meta: {
        right: ['其他原因明细列表'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/ownerAdviceList',
      component: ownerAdviceList,
      name: '业主意见明细列表',
      meta: {
        right: ['业主意见明细列表'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/OwnerEvaluationStatistics',
      component: OwnerEvaluationStatistics,
      name: '评价统计',
      meta: {
        right: ['评价统计'],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/ownerEvaluationDetail',
      component: ownerEvaluationDetail,
      name: '业主评价详情',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/institutionsEvaluation',
      component: institutionsEvaluation,
      name: '各区业主评价情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/orgScoreRank',
      component: orgScoreRank,
      name: '评分倒数排名',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, {
      path: '/orgRankState',
      component: orgRankState,
      name: '机构排名情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/orgRankStates',
      component: orgRankStates,
      name: '机构排名情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/PropertyProjectLists',
      component: PropertyProjectLists,
      name: '物业项目评分情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/DetailedCellRankings',
      component: DetailedCellRankings,
      name: '小区评分情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/statisticalDetails',
      component: statisticalDetails,
      name: '评价详情',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/evaluatePush',
      component: evaluatePush,
      name: '统计详情',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }
  ]
};

export default ownerEvaluationRouter;